import { Link } from "@tanstack/react-router";
import { FadeIn } from "~/components/fade-in";

export function Footer() {
  return (
    <FadeIn translateY={16} duration={500}>
      <footer className="border-t border-border px-6 py-10">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-4 text-sm text-muted-foreground md:flex-row">
          <Link to="/" className="flex items-center gap-2">
            <img
              src="/icon-256.png"
              alt="Overseer"
              className="h-6 w-6 rounded"
            />
            <span className="font-semibold text-foreground">Overseer</span>
          </Link>
          <div className="mx-auto max-w-md space-y-1.5 text-center md:px-6">
            <p className="text-foreground/80">
              &copy; {new Date().getFullYear()} Overseer. All rights reserved.
            </p>
            <p className="text-xs leading-relaxed text-muted-foreground/70">
              Overseer is an independent project and is not affiliated with,
              endorsed by, or sponsored by Studio Wildcard, Nitrado, or Discord.
            </p>
          </div>
          <div className="flex gap-4">
            <Link to="/terms" className="hover:text-foreground transition-colors">
              Terms
            </Link>
            <Link to="/privacy" className="hover:text-foreground transition-colors">
              Privacy
            </Link>
          </div>
        </div>
      </footer>
    </FadeIn>
  );
}
